import { useLocalStorage } from '@mantine/hooks';

import type { DashboardGridDataInput } from '#core/components/dashboard/schema.ts';

export interface DashboardBookmark extends DashboardGridDataInput {
  description?: string;
  /** Allow additional unknown properties for extensibility */
  [key: string]: unknown;
}

export const useDashboardBookmarks = () =>
  useLocalStorage<DashboardBookmark[]>({
    key: 'chart-grid-bookmarks',
    defaultValue: [],
    getInitialValueInEffect: false,
  });
